import type { FeedProduct, FeedSection } from "@/features/feed/contract"

const productsOf = (section: FeedSection): FeedProduct[] => {
  switch (section.type) {
    case "PRODUCT_RAIL":
    case "COMPACT_PRODUCT_RAIL":
    case "BLUE_PRODUCT_RAIL":
    case "PLAIN_PRODUCT_RAIL":
    case "DROP_RAIL":
    case "PRODUCT_CAROUSEL":
      return section.data.products
    case "BRAND_SPOTLIGHT":
    case "LOOK_CARD":
    case "BRAND_SPOTLIGHT_BAND":
      return section.data.tiles
    case "BENTO_GRID":
    case "BENTO":
      return section.data.tiles.flatMap((tile) => (tile.kind === "product" && tile.product ? [tile.product] : []))
    case "PRODUCT_SPOTLIGHT":
      return section.data.product ? [section.data.product] : []
    case "OUTFIT_ROW":
    case "LOOK_ROW":
      return section.data.cards.flatMap((card) => card.tiles)
    default:
      return []
  }
}

export const collectFeedProducts = (section: FeedSection): FeedProduct[] => {
  const found = new Map<string, FeedProduct>()
  for (const product of productsOf(section)) {
    if (!found.has(product.id)) found.set(product.id, product)
  }
  return [...found.values()]
}

export const paintedFeedProducts = (section: FeedSection, node: ParentNode): FeedProduct[] => {
  const stamped = new Set(Array.from(node.querySelectorAll("[data-nelo-item]"), (card) => card.getAttribute("data-nelo-item")))
  return collectFeedProducts(section).filter((product) => stamped.has(product.id))
}
